import type {DateTimeString, TodoPriority, UserList, UserRef} from "../util/CommonTypes";
import {Task} from "@t/task/Task.ts";
import {isOfType, SrcType} from "@t/meta/SourceType.ts";

export const ContactType = {
    PHONE: 1,
    FAX: 2,
    EMAIL: 3,
    LETTER: 4,
    MEETING: 5,
    OTHER: 6
} as const;
export type ContactType = typeof ContactType[keyof typeof ContactType];

/**
 * Represents communication implemented by Contact row object.
 */
export interface Contact {
	_type: 6;

    id: number;
    type: ContactType;
    entered?: DateTimeString;
    enteredBy?: UserRef;
    modified?: DateTimeString;
    modifiedBy?: UserRef;
    planContact?: DateTimeString;
    contacted?: DateTimeString;
    delegateTime?: DateTimeString;
    owners?: UserList;
    responsibles?: UserList;
    subject?: string;
    description?: string;
    letterBody?: string;
	icon: string;
    priority?: TodoPriority;
    notification?: number;
    notifyFlag?: number;
    ringBefore?: number;
    agendaCategory?: string;
    symbol?: string;
    result?: string;
    audioURL?: string;
    phone?: string;
    stateCall?: string;
    callDuration?: number;
    callUid?: string;
    showInCalendar?: boolean;
    collectingFeedback?: boolean;
    private?: boolean;

    customer?: number;
    branch?: number;
    person?: number;
    customerFileAs?: string;
    opportunity?: number;
    opportunityName?: string;
    busCase?: number;
    busCaseName?: string;
    problem?: number;
    problemFileAs?: string;
    campaign?: number;
    campaignSymbol?: string;

    project?: number;
    projectName?: string;
    sequence?: number;
}


export function isContact(obj: any): obj is Contact {
	return isOfType(obj, SrcType.CONTACT);
}
